export default "__VITE_ASSET__8b943b8f__"